import { CreateProductTemplate } from "@/components/Templates";
import { useCreateProductPage } from "@/hooks/useCreateProductPage";

export function CreateProductPage() {
  const createProduct = useCreateProductPage();

  return <CreateProductTemplate {...createProduct} />;
}
